import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import updateOperatorTaskStatus from './useUpdateOperatorTaskStatus.request';

import { TaskStatus, WaitingOnReason } from 'modules/common/components/MemberOperator/MemberOperator.interfaces';

/** @public */
export default function useUpdateOperatorTaskStatus(
    options: UseMutationOptions<
        number,
        Error,
        {
            id: string;
            status: TaskStatus;
            execute_handlers_async?: boolean;
            completion_payload?: Record<string, any> | undefined;
            waiting_on?: WaitingOnReason;
        }
    > = {}
) {
    return useMutation({
        mutationFn: ({
            id,
            status,
            execute_handlers_async,
            completion_payload = undefined,
            waiting_on = undefined,
        }: {
            id: string;
            status: TaskStatus;
            execute_handlers_async?: boolean;
            completion_payload?: Record<string, any> | undefined;
            waiting_on?: WaitingOnReason;
        }) => updateOperatorTaskStatus(id, status, execute_handlers_async, completion_payload, waiting_on),
        ...options,
    });
}
